import React, { useState, useEffect} from 'react';

import { useHistory } from 'react-router-dom';

// import { FiEdit3 } from 'react-icons/fi';
import { MdDeleteOutline } from "react-icons/md";


import './newsHandler.css'



const NewsHandler = () => {

  const history = useHistory();
  const [news, setNews] = useState([])
  const [loaded, setIsLoaded] = useState(false);

  // Fetching all news
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/news');
        const responseData = await response.json();
        setNews(responseData.news)
        setIsLoaded(true);

      } catch (err) {
        console.log(err)
      }
      
    };
    fetchData();
  }, [])

  // Open news
  const handleOpenNews = (newsId) => {
    history.push(`/news/${newsId}`);
    window.location.reload();
  };


  // Edit
  // const handleEditNews = (newsId) => {
  //   history.push(`/update/${newsId}`);
  //   window.location.reload();
  // }

  // Delete news
  const handleDeleteNews = async (newsId) => {
    const confirm = window.confirm('Are sure you want to delete this news!')

    if(!confirm){
        return;
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/news/${newsId}`,{
            method: 'DELETE',
        });

        if (!response.ok){
            throw new Error('Could not delete news for provided id.')
        };

        setNews(prevNews => prevNews.filter(n => n.id !== newsId));

    } catch (err) {
        console.log(err)
    }
  }

  return (
    <main className='newsHandler-lists-container'>
      <ul>             
        {news.length === 0 ? ( 
          <h1 style={{textAlign: 'center'}}>Мэдээ байгүй байна</h1>
        ) : (
        loaded && news.map((n,index) => (
          <li 
            key={index} 
            className='newsHandler-lists-li'
          >
            <p onClick={() => handleOpenNews(n.id)}>{n.title}</p> 
                 
            <span style={{marginRight: '30px'}}>
              {/* <FiEdit3 
                style={{fontSize: '25px', color: 'blue', marginRight: '15px'}}
                onClick={() => handleEditNews(n.id)}/> */}
              <MdDeleteOutline 
                style={{fontSize: '25px', color: 'red', marginRight: '15px'}}
                onClick={() => handleDeleteNews(n.id)}/>
            </span>
          </li>
        )))}
      
      </ul>
    </main>
  )
}
export default NewsHandler;

